export const formatProStartDate = (date: string | Date | null): string => {
  if (!date) {
    return '-';
  }

  const parsedDate = new Date(date);
  const weekday = parsedDate.toLocaleDateString('fa-IR', {weekday: 'long'});
  const readableDate = parsedDate.toLocaleDateString('fa-IR', {
    month: 'long',
    day: 'numeric'
  });

  return `${weekday} ${readableDate}`;
};
